<!-- Menus are wrapped in ng-template for lazy loading menu content -->

<!-- Menu trigger -->
<button mat-icon-button [matMenuTriggerFor]="elementOptionsMenu" [disabled]="disabled">
  <mat-icon>more_vert</mat-icon>
</button>

<!-- Main menu -->
<mat-menu #elementOptionsMenu="matMenu">
  <ng-template matMenuContent>

    <button mat-menu-item *ngIf="config.setRatioBy" [matMenuTriggerFor]="setRatioBySubmenu">
      <mat-icon>aspect_ratio</mat-icon>
      {{ 'setRatioBy' | translate }}
    </button>

    <button mat-menu-item *ngIf="config.setRatioAs" [matMenuTriggerFor]="setRatioAsSubmenu">
      <mat-icon>aspect_ratio</mat-icon>
      {{ 'setRatioAs' | translate }}
    </button>

    <mat-divider
      *ngIf="(config.setRatioAs || config.setRatioBy) && config.changeOrder">
    </mat-divider>

    <button mat-menu-item *ngIf="config.changeOrder" (click)="changeOrder()">
      <mat-icon>low_priority</mat-icon>
      {{ 'clustersorting' | translate }}
    </button>

  </ng-template>
</mat-menu>


<!-- Submenu: Ratio as -->
<mat-menu #setRatioAsSubmenu="matMenu">
  <ng-template matMenuContent>
      <button mat-menu-item (click)="setRatioAs('ratio')" [class.active]="building.ratioAs === 'ratio'">
        <mat-icon>settings_ethernet</mat-icon>
        {{ 'ratio' | translate }}
      </button>
      <button mat-menu-item (click)="setRatioAs('bvo')" [class.active]="building.ratioAs === 'bvo'">
        <mat-icon>tab_unselected</mat-icon>
        {{ 'bvo' | translate: 'upperCase' }}
      </button>
  </ng-template>
</mat-menu>

<!-- Submenu: Ratio by -->
<mat-menu #setRatioBySubmenu="matMenu">
  <ng-template matMenuContent>
      <button mat-menu-item (click)="setRatioBy('building')" [class.active]="!building.ratioBy || building.ratioBy === 'building'">
        <mat-icon>location_city</mat-icon>
        {{ 'building' | translate }}
      </button>
      <button mat-menu-item (click)="setRatioBy('cluster')" [class.active]="building.ratioBy === 'cluster'">
        <mat-icon>view_day</mat-icon>
        {{ 'cluster' | translate }}
      </button>
  </ng-template>
</mat-menu>
